// extracted by mini-css-extract-plugin
export default {"base":"DialogConfirmation_base__R6ra+","content":"DialogConfirmation_content__7FOLJ","button":"DialogConfirmation_button__Bc1wU"};